import * as angular from "angular";
import { CheckManager } from "../shared/check-manager";
import { Filter } from "../models/filter.model";
import { Invite } from "../models/invite.model";
import { InviteService } from "../services/invite.service";

export class InviteDataProvider {
    private $q: any;
    private $http: any;
    private service: InviteService;
    public checkManager: CheckManager;
    private $timeout: any;
    private modelsUtils: any;

    public filters = new Filter();
    public invites: Invite[] = [];
    public loading = true;
    public count: number | null = null;

    constructor(
        $q: any,
        $http: any,
        InviteService: InviteService,
        $timeout: any,
        ModelsUtils: any
    ) {
        this.$q = $q;
        this.$http = $http;
        this.service = InviteService;
        this.checkManager = new CheckManager(this.invites);
        this.$timeout = $timeout;
        this.modelsUtils = ModelsUtils;
    }

    clearAll(): void {
        this.invites = [];
    }

    all(filters?: Filter, reset?: boolean): Promise<object[]> {
        if (!reset && this.invites && this.invites.length) {
            this.loading = false;
            return this.$q.resolve(this.invites);
        } else {
            this.loading = true;
            const deferred = this.$q.defer();

            let filterData = null;
            if (filters) {
                filterData = filters.nonEmptyValues();
            }

            this.service.all({ filters: filterData }).then(
                (response: object) => {
                    const json = response["data"];
                    this.loading = false;
                    this.invites.splice(0, this.invites.length);
                    for (let i = 0; i < json.data.length; i++) {
                        this.invites.push(
                            this.modelsUtils.invite(json.data[i])
                        );
                    }
                    this.count = this.invites.length;
                    deferred.resolve(this.invites);
                },
                (error: object) => {
                    this.loading = false;
                    this.count = 0;
                    this.invites.splice(0, this.invites.length);
                    deferred.reject(error);
                }
            );
            return deferred.promise;
        }
    }

    setFilter(setFilters: Filter): void {
        this.filters = setFilters;
        this.resetItems();
    }

    resetItems(): void {
        this.count = undefined;
        this.all(this.filters, true);
    }

    bulkDelete(ids: number[]): Promise<object[]> {
        const deferred = this.$q.defer();
        this.service.bulkDelete({ ids }).then((response: object) => {
            const json = response["data"];
            if (json.success) {
                this.resetItems();
                this.checkManager.removeCheckedItems();
                deferred.resolve(json.data);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    bulkResend(ids: number[]): Promise<object[]> {
        const deferred = this.$q.defer();
        this.service.bulkResend({ ids }).then((response: object) => {
            const json = response["data"];
            if (json.success) {
                this.checkManager.checkAll(false);
                deferred.resolve(json.data);
            } else {
                deferred.reject(json);
            }
        });
        return deferred.promise;
    }

    replaceInvite(invite: Invite): void {
        this.$timeout(() => {
            let existingInvite = this.inviteWithID(invite.campaigninviteid);
            if (existingInvite) {
                angular.extend(existingInvite, invite);
            } else {
                this.invites.unshift(invite);
                this.count++;
            }
        }, 100);
    }

    spliceInvite(invite: Invite): void {
        if (this.invites.length) {
            let inviteIndex = this.invites
                .map((el: Invite) => {
                    return el.campaigninviteid;
                })
                .indexOf(invite.campaigninviteid);

            if (inviteIndex > -1) {
                this.invites.splice(inviteIndex, 1);
            }
        }
    }

    pendingApprovalCount(): number {
        return this.invites.filter((invite: Invite) =>
            invite.isPendingApproval()
        ).length;
    }

    inviteWithID(id: number | string): Invite {
        for (let i = 0; i < this.invites.length; i++) {
            if (this.invites[i].campaigninviteid == id) {
                return this.invites[i];
            }
        }
        return null;
    }

    processSocketUpdate(socketData: object): void {
        if (this.invites) {
            this.replaceInvite(this.modelsUtils.invite(socketData));
        }
    }

    processSocketCreate(socketData: object): void {
        if (this.invites) {
            this.replaceInvite(this.modelsUtils.invite(socketData));
        }
    }

    processSocketDelete(socketData: any): void {
        if (this.invites.length) {
            let existingInvite = this.inviteWithID(socketData.campaigninviteid);
            if (existingInvite) {
                this.spliceInvite(existingInvite);
                this.count--;
            }
        }
    }
}

angular
    .module("vcDataProvider")
    .service("InviteDataProvider", InviteDataProvider);
